import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Label } from 'react-bootstrap';
import SearchBox from 'components/site/SearchBox';
import QuoteSearchStore from 'stores/quotes/QuoteSearchStore';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import _ from 'lodash';

class QuoteSearch extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    shipper: PropTypes.object,
  };

  static defaultProps = {
    defaultValue: '',
    disabled: false,
    placeholder: 'Search for quotes..',
    type: '',
    value: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      quotes: [],
    };
    this.handleSearch = _.debounce(this.handleSearch, 300);
  }

  componentDidMount() {
    QuoteSearchStore.addChangeListener(this.handleQuotesStoreChange);
  }

  componentWillUnmount() {
    QuoteSearchStore.removeChangeListener(this.handleQuotesStoreChange);
    QuoteSearchStore.clearSearchResults();
  }

  handleQuotesStoreChange = () => {
    const quotes = QuoteSearchStore.getSearchResults();
    this.setState({ quotes });
  };

  clear() {
    this.setState({ quotes: [] });
  }

  handleChange = (nGram) => {
    if (!nGram || nGram.length <= 2) {
      QuoteSearchStore.clearSearchResults();
    }

    if (this.props.onChange) {
      this.props.onChange(nGram);
    }
  };
  handleSearch(nGram, shipper) {
    const search = nGram ? nGram.toUpperCase() : '';
    CustomersActionCreators.searchQuotes(search, shipper);
  }

  handleQuoteSelect(value, item) {
    QuoteSearchStore.clearSearchResults();
    this.props.onSelect(value, item);
  }

  renderItem = (item) => (
    <a
      id={item._id}
      className="userDetailsShipper list-group-item"
      style={{ cursor: 'pointer' }}
      key={item.value}
    >
      <p className="list-group-item-heading">
        <Label bsStyle="info">{item.shipment_type}</Label>&nbsp;
        <span className="searchName">{item.quote_id}</span>
      </p>
    </a>
  );

  render() {
    return (
      <SearchBox
        items={this.state.quotes}
        clear={() => this.clear()}
        disabled={this.props.disabled}
        search={(nGram) => this.handleSearch(nGram, this.props.shipper)}
        placeholder={this.props.placeholder}
        defaultValue={this.props.defaultValue}
        value={this.props.value}
        onChange={(value) => this.handleChange(value)}
        onSelect={(value, item) => this.handleQuoteSelect(value, item)}
        getItemValue={this.props.displayValue}
        renderItem={this.renderItem}
        inputStyle={this.props.inputStyle}
      />
    );
  }
}

export default withRouter(QuoteSearch);
